import {useMemo} from 'react';

import {applyTeamFilter, matchesMemberSearch, matchesStatusTab} from '../utils';

import type {TeamFilterState} from '../config/team-filter.config';
import type {TeamStatusTab} from '../types';
import type {FirmMemberDTO} from '@sollapay/types';

export function useFilteredTeamMembers(
  members: FirmMemberDTO[],
  searchText: string,
  statusTab: TeamStatusTab,
  filter: TeamFilterState
): FirmMemberDTO[] {
  return useMemo(() => {
    const result = members.filter(
      member => matchesStatusTab(member, statusTab) && matchesMemberSearch(member, searchText)
    );

    return applyTeamFilter(result, filter);
  }, [members, searchText, statusTab, filter]);
}
